import { initializeApp } from "firebase/app";
import { getToken, getMessaging, onMessage } from "firebase/messaging";
import { useState } from "react";

// const [sentFcm, setSentFcm] = useState(true);

const firebaseConfig = {
  // apiKey: "AIzaSyC6LJwOCz59yI_wZ1N3BGVUzJ7fzrkT4o4",
  // authDomain: "demobebu.firebaseapp.com",
  // projectId: "demobebu",
  // storageBucket: "demobebu.appspot.com",
  // messagingSenderId: "836912395201",
  // appId: "1:836912395201:web:a68c71acd67c1941243540",
  apiKey: "AIzaSyDYprtNxFWWn7QaWLZYjEBBi5RdHAmGWis",
  authDomain: "bebu-ebb9d.firebaseapp.com",
  projectId: "bebu-ebb9d",
  storageBucket: "bebu-ebb9d.appspot.com",
  messagingSenderId: "394161949677",
  appId: "1:394161949677:web:d38dfb2779ef2d8eee35e4",
  measurementId: "G-6XMHQW9B7Q",
};

// console.log("*** Firebase Config ***", firebaseConfig);

const firebaseApp = initializeApp(firebaseConfig);

if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("/firebase-messaging-sw.js")
    .then((registration) => {
      console.log("Service Worker registered:", registration);
      const messaging = getMessaging(firebaseApp);
      messaging.useServiceWorker(registration);
    })
    .catch((err) => {
      console.error("Service Worker registration failed:", err);
    });
}

// const messaging = getMessaging(firebaseApp);
export const messaging = getMessaging(firebaseApp);

export const generateToken = async () => {
  const permission = await Notification.requestPermission();
  // console.warn(permission);
  if (permission === "granted") {
    const token = await getToken(messaging, {
      vapidKey:
        "BBqTp4gYHtWGX757dMN7aLg0rHEOorX4yl-QVHLxy4ayhMYWXelII3_mc7zeeGyz417U2qQ5YDTh29ROyBmsgIM", //"BI5XkoqDAQniFBDKgc2ocE0Lar95D9uDC_bOPtJjarHJUN-iYPmU7PZ9P2G_S2M_gJYElUk47Y1iZlpz4DZmZFw",
    });
    console.log(token);
    localStorage.setItem("NewfcmBebu", JSON.stringify(token));
    return token;
  }
};

export default firebaseApp;

// export const updateNotification = async (token) => {
//   instance
//     .post(`/saveUnauthUsersDeviceDetails?id=1&FCM-TOKEN=${token}`)
//     .then((response) => {
//       console.warn(response.data);
//     })
//     .catch((error) => {
//       console.error("Error fetching data:", error);
//     })
//     .finally(() => {});
// };
